import {
    SET_LOADING,
    GET_INDICATORS,
    SET_INDICATOR,
    SET_LOADING_ERROR,
    GET_INDICATORS_ERROR,
    SET_INDICATOR_ERROR,
    DELETE_INDICATOR,
    DELETE_INDICATOR_ERROR,
    CLEAR_INDICATORS

} from '../actions/actions.js'

const initialState = {
    available_indicators: [],
    loading: false,
    error: null,
    active_indicators: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true,
            };
        case GET_INDICATORS:
            return {
                ...state,
                available_indicators: action.payload,
                loading: false,
            };
        case SET_INDICATOR:
            if(!state.active_indicators.includes(action.payload) ) {
                return {
                    ...state,
                    active_indicators: [...state.active_indicators, action.payload],
                };
            }
            else{
                return state
            }
        case CLEAR_INDICATORS:
            return {
                ...state,
                active_indicators: [],
            };
        case SET_LOADING_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case GET_INDICATORS_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case SET_INDICATOR_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        case DELETE_INDICATOR:
            return {
                ...state,
                active_indicators: state.active_indicators.filter((x) => x !== action.payload),
            };
        case DELETE_INDICATOR_ERROR:
            console.error(action.payload);
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};
